import { Box3, Object3D, Vector3 } from 'three';

export interface InspectedObject {
  name: string;
  type: string;
  min: string;
  max: string;
}

const format = (v: Vector3) => `${v.x.toFixed(4)}, ${v.y.toFixed(4)}, ${v.z.toFixed(4)}`;

export function inspectObjects(root: Object3D): InspectedObject[] {
  const rows: InspectedObject[] = [];
  root.traverse((object) => {
    if (!object.name && object.children.length === 0) return;
    const box = new Box3().setFromObject(object);
    rows.push({
      name: object.name || '(unnamed root)',
      type: object.type,
      min: box.isEmpty() ? '—' : format(box.min),
      max: box.isEmpty() ? '—' : format(box.max),
    });
  });
  return rows;
}
